import { render, staticRenderFns } from "./ExtensionCard.vue?vue&type=template&id=63dd7b74&scoped=true"
import script from "./ExtensionCard.vue?vue&type=script&lang=ts"
export * from "./ExtensionCard.vue?vue&type=script&lang=ts"
import style0 from "./ExtensionCard.vue?vue&type=style&index=0&id=63dd7b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd7b74",
  null
  
)

export default component.exports